import { useNavigate, useParams } from "react-router-dom";
import { useFetcher } from "~/hooks/useFetcher";
import { ROUTE_404 } from "~/router/constants";
import { CatalogTableEntity } from "~/types/interfaces/catalogResponse";

const { VITE_CATALOG_API } = import.meta.env;

const useDatasetTable = (fqn?: string) => {
  const navigate = useNavigate();
  const { tableFQN = fqn } = useParams();

  const resp = useFetcher<CatalogTableEntity>(
    tableFQN ? `${VITE_CATALOG_API}/tables/fqn/${tableFQN}` : null,
    { shouldCamelize: true }
  );

  if (resp.error?.status >= 400 && resp.error.status < 500) {
    navigate(ROUTE_404, { replace: true });
  }

  return resp;
};

export default useDatasetTable;
